module.exports = __webpack_public_path__ + "static/media/6.ebb5419a.png";